import React from "react"
import {connect} from 'react-redux'
//import {set} from 'lodash'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment"
// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import CheckboxTree from "./CheckboxTree.jsx"
import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {groupBy, orderBy} from 'lodash'
import Table from "components/Table/Table.jsx"
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"

import {
  adminReportContractDetailsFetch,
} from 'actions/ibReports'
import {
  profilesFetch,
  profileFilter
} from 'actions/profiles'
import {
	profileIbTreeFetch
} from 'actions/ibTrees'
import {
  symbolsFetch,
  symbolFilter
} from 'actions/symbols'
import {
  profileSpecialCasesFetch
} from 'actions/profileSpecialCases'
import{
  subProfileRulesFetch
} from 'actions/subProfileRules'
import {
  symbolGroupsFetch,
  symbolGroupFilter
} from 'actions/symbolGroups'
import {
  currenciesFetch,
  currencyFilter
} from 'actions/currencies'
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  line: {
    borderTop: '2px solid transparent',
    width: '90%',
    position: 'absolute',
    bottom: '-15px'
  },
  sectionHeader: {
    background: 'gray',
    color: 'white'
  }
}

class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      profileId: 0,
      ibId: 0,
      tree: [],
      treeHelper: [],
      reportData: [],
      tablesCollaplse: {}
    }
	}
	
	profileChange(e, filter){
		let value = e.target.value
    this.props.ibTreesFetch({profileId: value}).then((tree) => {
      let treeHelper= tree.map((x)=> {
        x.expanded = false
        x.selected = false
        return x
      })
      const ibs = tree.map((data) => {
        return data.ib
      })
      if(!ibs[0]){
        this.setState({
          ...this.state,
          [filter]: value,
          ibId: '',
          tree: this.buildTree(tree),
          treeHelper: treeHelper,
          reportData: [],
          errorMessage: 'There are no contract details for this profile'
        })
        return
      }
      this.setState({
        ...this.state,
        [filter]: value,
        ibId: ibs[0].ibId,
        tree: this.buildTree(tree),
        treeHelper: treeHelper,
        errorMessage: null
      },()=> this.fetchReport())
    })
	}
	handleChange(e, filter){
    let value = e.target.value
    if(filter === 'ibId'){
      let node = this.state.treeHelper.find((a)=> a.ib && a.ib.ibId === value)
      this.selectTreeNode(node)
    }
		this.setState({[filter]: value},() => this.fetchReport())
  }
  clickTreeNode(node){
    this.selectTreeNode(node)
		this.setState({ibId: node.ib.ibId},() => this.fetchReport())
  }
  findIbsInTree(newTree, node){
    const treeHelper = this.state.treeHelper
    treeHelper.forEach(element => {
      if(element.ibTreeNodeId === node.ibTreeNodeId && node.parentIb){
        treeHelper.forEach((item)=>{
          if(node.parentIb.ibId === item.ib.ibId){
            newTree.push(item)
            if(item.parentIb){
              this.findIbsInTree(newTree, item)
            }
          }
        })
      }
    })
  }
  fetchReport(){
		const{ibId, profileId} = this.state
    const params = {
			ibId,
			profileId
    }
    return this.props.fetch(params).then(async(data) => {
      let newData = [...data]
      let specialcases = [[]]
      const treeItem = this.state.treeHelper.find((t)=> t.ib.ibId === ibId)
      
      if(treeItem.subProfileId){
        let tree = [treeItem] 
        this.findIbsInTree(tree, treeItem)
        let promises = tree.map((i)=>{
          if(i.subProfileId){
            return this.getSubProfileRulesFetch(i.subProfileId)
          } else {
            return this.getProfileSpecialCases(profileId)
          }
        })
        const subprofileRules = await Promise.all(promises)
        subprofileRules.forEach((arr)=>{
          specialcases[0] = [...specialcases[0], ...arr]
        })
      } else {
        specialcases = await Promise.all([this.getProfileSpecialCases(profileId)])
      }

      newData.forEach((sym) => {
        let symbolObj = this.props.symbols.find((x) => x.symbolId === sym.id)
        sym.symbolType = symbolObj.type

        let specialCase = specialcases[0].find((x)=> x.symbols.find((y)=> y.type === sym.symbolType && y.symbolId === sym.id))
        sym.isGeneralSettingSymbol = !specialCase
        let generalTypeSetting = specialcases[0].find((x)=> x.symbols.length === 0 && x.symbolTypes.includes(symbolObj.type))
        sym.symbolSettingId = specialCase
          ? specialCase.profileSpecialCaseId
          : generalTypeSetting ? generalTypeSetting.profileSpecialCaseId : null
        
        sym.hasProfileSettings = !sym.symbolSettingId
      })

      let groups = groupBy(newData, 'symbolType')
      //for each group find those who has the same value#
      let newg = {}

      Object.keys(groups).forEach((key) => {
        let groupSymbols = groups[key]
        // group those with the same values and same symbolSettingId
        groupSymbols.forEach((v)=> {
          let symbolExist = false
          if(newg[key]){
            newg[key].forEach(a=>{
              if(a.find((s) => s.id === v.id)) {
                symbolExist = true
                return
              }
            })
          }
          if(symbolExist) return
          //let symbols = groupSymbols.filter((f)=> f.commission === v.commission && f.commissionCurrencyId === v.commissionCurrencyId && f.commissionType === v.commissionType && f.markup === v.markup && f.percentage === v.percentage && f.spread === v.spread)
          let symbols = groupSymbols.filter(f => f.commission === v.commission && f.commissionCurrencyId === v.commissionCurrencyId && f.commissionType === v.commissionType && f.markup === v.markup && f.percentage === v.percentage && f.spread === v.spread)
          if(!newg[key]){
            newg[key] = []
          }
          newg[key].push(symbols) 
        })
      })
      const orderedGroups = this.orderGroups(newg)
      this.setState({reportData: orderedGroups})
    })
  }
  orderGroups(groups){
    let newgroups = {}
    if(groups.FOREX)newgroups = {FOREX: groups.FOREX}
    if(groups.INDEX)newgroups = {...newgroups, INDEX: groups.INDEX}
    if(groups.COMMODITY)newgroups = {...newgroups, COMMODITY: groups.COMMODITY}
    if(groups.CRYPTO)newgroups = {...newgroups, CRYPTO: groups.CRYPTO}
    if(groups.FUTURE)newgroups = {...newgroups, FUTURE: groups.FUTURE}
    if(groups.SHARE)newgroups = {...newgroups, SHARE: groups.SHARE}
    newgroups = {...newgroups, ...groups}
    return newgroups
  }
	componentDidMount(){
    this.props.profileFilter({size: 100000})
    this.props.symbolFilter({size: 100000})
    this.props.symbolsFetch()
    this.props.currencyFilter({size: 100000})
    this.props.currenciesFetch()
    this.props.symbolGroupFilter({size: 100000})
    this.props.symbolGroupsFetch()

		this.props.profilesFetch().then((p) =>{
			if(p.content.length !== 0){
				const profile = p.content[0].profileId
				//this.setState({profileId: profile})
				this.props.ibTreesFetch({profileId: profile}).then((tree) => {
          let treeHelper= tree.map((x)=> {
            x.expanded = false
            x.selected = false
            return x
          })
          const ibs = tree.map((data) => {
            return data.ib
          })
          if(!ibs[0]){
            this.setState({
              tree: this.buildTree(tree),
              treeHelper: treeHelper,
              profileId: profile,
              ibId: '',
              reportData: [],
              errorMessage: 'There are no contract details for this profile'
            })
            return
          }
          this.setState({
            tree: this.buildTree(tree),
            treeHelper: treeHelper,
            profileId: profile,
            ibId: ibs[0].ibId,
            errorMessage: null
          },()=> this.fetchReport())
        })
			}
		})
  }

  getProfileSpecialCases(profile){
    return new Promise(async(res,rej)=>{
      await this.props.profileSpecialCasesFetch(profile).then((result)=>{
          res(result)
      }).catch((err)=>{
        rej(err)
      })
    })
  }
  getSubProfileRulesFetch(subProfile){
    return new Promise(async(res,rej)=>{
      await this.props.subProfileRulesFetch(subProfile).then((result)=>{
        let data = []
        result.forEach((item)=> {
          let newCase = {...item}
          newCase.profileSpecialCaseId = item.subProfileRuleId
          newCase.symbols = []
          item.symbols.forEach((symb)=>{
            let symbolObj = this.props.symbols.find((x)=> x.symbolId === symb)
            newCase.symbols.push(symbolObj)
          })
          data.push(newCase)
        })
        res(data)
      }).catch((err)=>{
        rej(err)
      })
    })
  }
  
  buildTree(ibtree){
    const tree = this.unflatten(ibtree)
    return tree
  }
  unflatten(ibTrees) {
    var tree = [],
        mappedArr = {},
        arrElem,
        mappedElem;

    for(var i = 0, len = ibTrees.length; i < len; i++) {
      arrElem = ibTrees[i];
      mappedArr[arrElem.ib.ibId] = arrElem;
      mappedArr[arrElem.ib.ibId]['parentid'] = arrElem.parentIb ? arrElem.parentIb.ibId : 0
      mappedArr[arrElem.ib.ibId]['children'] = [];
    }

    for (var id in mappedArr) {
      if (mappedArr.hasOwnProperty(id)) {
        mappedElem = mappedArr[id];
        if (mappedElem.parentid && mappedArr[mappedElem['parentid']]) {
          mappedArr[mappedElem['parentid']]['children'].push(mappedElem);
        }
        else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  }
  setTreeNodeVisibility(node){
    let {treeHelper} = this.state
    treeHelper.forEach((a) => {
      if(a.ibTreeNodeId === node.ibTreeNodeId){
        a.expanded = !a.expanded
      }
    })
    this.setState({treeHelper: treeHelper})
  }
  selectTreeNode(node){
    let {treeHelper} = this.state
    treeHelper.forEach((a) => {
      if(a.ibTreeNodeId === node.ibTreeNodeId){
        a.selected = true
      }else{
        a.selected = false
      }
      a.expanded = false
    })

    //expand parent nodes
    if(node.parentIb){
      this.findParentNode(treeHelper, node)
    }
    this.setState({treeHelper: treeHelper})
  }
  findParentNode(treeHelper, node){
    treeHelper.forEach(element => {
      if(element.ibTreeNodeId === node.ibTreeNodeId && node.parentIb){
        treeHelper.forEach((item)=>{
          if(node.parentIb.ibId === item.ib.ibId){
            item.expanded = true
            if(item.parentIb){
              this.findParentNode(treeHelper, item)
            }
          }
        })
      }
    })

  }
	renderFilters(){
		const {classes, profiles, ibTrees} = this.props
    const {profileId, ibId, treeHelper} = this.state
		const ibs = ibTrees.map((data) => {
			return data.ib
    })
    const tree = this.state.tree
		return (
			<GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="profileId" className={classes.selectLabel} >
              Profile
            </InputLabel>
            <Select
              value={profileId}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.profileChange(event, "profileId"),
                id: "profileId",
                name: "profileId"
              }}>
              {orderBy(profiles, 'name')
                .map((e) => (
                  <MenuItem
                    key={e.profileId}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.profileId}>
                    {`${e.name} (${e.profileId})`}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
				<GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="ibId" className={classes.selectLabel} >
              Ib
            </InputLabel>
            <Select
              value={ibId || -1}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "ibId"),
                id: "ibId",
                name: "ibId"
              }}>
                {orderBy(ibs, 'name')
                  .map((e) => (
                    <MenuItem
                      key={e.ibId}
                      classes={{
                        root: classes.selectMenuItem
                      }}
                      value={e.ibId}>
                      {e.name + ' ' + e.lastName}
                    </MenuItem>
                  )
                )}
            </Select>
          </FormControl>
          
        </GridItem>
				<GridItem>
          <CheckboxTree
            nodes={tree}
            treeHelper={treeHelper}
            setNodeVisibility={(x) => this.setTreeNodeVisibility(x)}
            onClickTreeNodeAction={(x) => this.clickTreeNode(x)}
          />
        </GridItem>
			</GridContainer>
		)
  }
  collapseTable(tableKey){
    let {tablesCollaplse} = this.state
    if(tablesCollaplse[tableKey]){
      tablesCollaplse[tableKey].collapse = !tablesCollaplse[tableKey].collapse
    } else {
      tablesCollaplse[tableKey] = {collapse: false}
    }
    
    this.setState({...this.state, tablesCollaplse})
  }
  createGenericTable(type, group, i){
    const {tablesCollaplse} = this.state
    const isGeneral = group[0].hasProfileSettings || group[0].isGeneralSettingSymbol
    const groupData = group.length > 5
      && (!tablesCollaplse[type+'_'+i] || (tablesCollaplse[type+'_'+i] && tablesCollaplse[type+'_'+i].collapse))
        ? group.slice(0, 5)
        : group
    const tableRow = isGeneral ? [{...groupData[0], showValues: true}] : groupData
    const collapseBtnTxt =  group.length > 5
      && (!tablesCollaplse[type+'_'+i] || (tablesCollaplse[type+'_'+i] && tablesCollaplse[type+'_'+i].collapse))
      ? 'More'
      :'Less'
    return(
      <GridContainer key={type+'_'+i} style={{padding: '15px 10px'}}>
        <GridItem xs={3}>
          <div style={{display: 'block', marginTop: '17px', height: isGeneral ? 'auto' : '40px'}}>
            {isGeneral ? 'General Settings' : <div>Option Settings -<span style={{marginLeft: 5}}>{type}</span></div>}
          </div>
          {isGeneral && (
            <div style={{width: '100%', display: 'flex', paddingTop: '15px', paddingLeft:'10px', alignItems: 'center'}}>
              <span style={{width: '90px', textAlign: 'right'}}>{type}</span>
              <div>
                <Checkbox
                  checked={true}
                  style={{height: '28px', color: '#525252'}}
                  icon={<Check />}
                />
              </div>
            </div>
          )}
          
          <div style={{paddingLeft: '10px', display: 'flex', flexDirection: 'column'}}>
            {groupData.map((group, index)=> {
              return(
                <div key={index} style={{width: '100%', display: 'flex', paddingTop: isGeneral ? '15px' : 0, paddingLeft:'10px', alignItems: 'center', height: isGeneral ? 'auto' : '48px'}}>
                  <span style={{width: '120px', textAlign: 'right'}}>{group.name}</span>
                  <div>
                    <Checkbox
                      checked={true}
                      style={{height: '28px', color: '#525252'}}
                      icon={<Check />}
                    />
                  </div>
                </div>
              )
            })}
            {group.length > 5 && (
              <div
                onClick={()=> this.collapseTable(type+'_'+i)}
                style={{
                  width: '100%',
                  color: '#0a337a',
                  display:'flex',
                  alignItems:'center',
                  cursor: 'pointer',
                  paddingLeft:'10px',
                  paddingTop: '10px'
                  }
                }>
                <span style={{width: '130px', textAlign: 'right', textDecoration: 'underline'}}>{collapseBtnTxt}</span>
                {collapseBtnTxt === 'More' ? <ArrowDownward/> : <ArrowUpward/>}
              </div>
            )}
          </div>
        </GridItem>
        <GridItem xs={9}>
          <Table
            striped
            tableHeaderColor="primary"
            tableHead={{       
              spread:"Spread Rebate (pips)",
              markup:"Markup Rebate (pips)",
              commission: 'Commission Rebate'
            }}
            tableData={tableRow.map((e,i) => {
              const currency = this.props.currencies.find((c)=> c.currencyId === e.commissionCurrencyId)
              return[
                e.showValues ? Math.round(e.spread * 100) / 100 : '',
                e.showValues ? Math.round(e.markup * 100) / 100 : '',
                e.showValues ? (<div>
                  <span style={{padding:'0 20px 0 0'}}>{Math.round(e.commission * 100) / 100}</span>
                  <span style={{padding:'0 20px 0 0'}}>{currency.name}</span>
                  <span>{e.commissionType}</span>
                </div>) : ''
              ]}
            )}
          />
        </GridItem>
      </GridContainer>
    )
  }
  createShareTable(type, group, i){
    const {tablesCollaplse} = this.state
    const isGeneral = group[0].hasProfileSettings || group[0].isGeneralSettingSymbol
    const groupData = group.length > 5
      && (!tablesCollaplse[type+'_'+i] || (tablesCollaplse[type+'_'+i] && tablesCollaplse[type+'_'+i].collapse))
        ? group.slice(0, 5)
        : group
    const tableRow = isGeneral ? [{...groupData[0], showValues: true}] : groupData
    const collapseBtnTxt =  group.length > 5
      && (!tablesCollaplse[type+'_'+i] || (tablesCollaplse[type+'_'+i] && tablesCollaplse[type+'_'+i].collapse))
      ? 'More'
      :'Less'
    return(
      <GridContainer key={type+'_'+i} style={{padding: '15px 10px'}}>
        <GridItem xs={3}>
          <div style={{display: 'block', marginTop: '17px', height: isGeneral ? 'auto' : '40px'}}>
            {isGeneral ? 'General Settings' : <div>Option Settings -<span style={{marginLeft: 5}}>{type}</span></div>}
          </div>
          {isGeneral && (
            <div style={{width: '100%', display: 'flex', paddingTop: '15px', paddingLeft:'10px', alignItems: 'center'}}>
              <span style={{width: '90px', textAlign: 'right'}}>{type}</span>
              <div>
                <Checkbox
                  checked={true}
                  style={{height: '28px', color: '#525252'}}
                  icon={<Check />}
                />
              </div>
            </div>
          )}
          
          <div style={{paddingLeft: '10px', display: 'flex', flexDirection: 'column'}}>
            {groupData.map((group, index)=> {
              return(
                <div key={index} style={{width: '100%', display: 'flex', paddingTop: isGeneral ? '15px' : 0, paddingLeft:'10px', alignItems: 'center', height: isGeneral ? 'auto' : '48px'}}>
                  <span style={{width: '120px', textAlign: 'right'}}>{group.name}</span>
                  <div>
                    <Checkbox
                      checked={true}
                      style={{height: '28px', color: '#525252'}}
                      icon={<Check />}
                    />
                  </div>
                </div>
              )
            })}
            {group.length > 5 && (
              <div
                onClick={()=> this.collapseTable(type+'_'+i)}
                style={{
                  width: '100%',
                  color: '#0a337a',
                  display:'flex',
                  alignItems:'center',
                  cursor: 'pointer',
                  paddingLeft:'10px',
                  paddingTop: '10px'
                  }
                }>
                <span style={{width: '130px', textAlign: 'right', textDecoration: 'underline'}}>{collapseBtnTxt}</span>
                {collapseBtnTxt === 'More' ? <ArrowDownward/> : <ArrowUpward/>}
              </div>
            )}
          </div>
        </GridItem>
        <GridItem xs={9}>
          <Table
            striped
            tableHeaderColor="primary"
            tableHead={{       
              spread:"Spread Rebate (pips)",
              markup:"Markup Rebate (pips)",
              percentage: 'Rebate On Shares',
              commission: 'Commission Rebate'
            }}
            tableData={tableRow.map((e,i) => {
              const currency = this.props.currencies.find((c)=> c.currencyId === e.commissionCurrencyId)
              return[
                e.showValues ? Math.round(e.spread * 100) / 100 : '',
                e.showValues ? Math.round(e.markup * 100) / 100 : '',
                e.showValues ? Math.round(e.percentage * 100) / 100 : '',
                e.showValues ? (<div>
                  <span style={{padding:'0 20px 0 0'}}>{Math.round(e.commission * 100) / 100}</span>
                  <span style={{padding:'0 20px 0 0'}}>{currency.name}</span>
                  <span>{e.commissionType}</span>
                </div>) : ''
              ]}
            )}
          />
        </GridItem>
      </GridContainer>
    )
  }
  createTypeTables(type, symbolTypeGroups){
    // for each group render table
    return symbolTypeGroups.map((group, i)=>{
      if(type === 'SHARE'){
        return this.createShareTable(type, group, i)
      } else {
        return this.createGenericTable(type, group, i)
      }
    })
  }

  render() {
    const {classes} = this.props
    const {reportData} = this.state

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>My Reports / Contract Details</h4>
            </CardHeader>
            <CardBody>
							{this.renderFilters()}
							
              <div style={{maxHeight: '500px', overflowY: 'auto', overflowX: 'hidden', border: '1px solid silver'}}>

                {this.state.errorMessage && (
                  <div style={{padding: '10px', fontStyle: 'italic'}}>
                    <span>{this.state.errorMessage}</span>
                  </div>
                )}
                {Object.keys(reportData).map((key) => {
                  const symbolTypeData = reportData[key]
                  const symbolTypeDataOrdered = orderBy(symbolTypeData, (g)=>{
                    return g.find((x)=> x.hasProfileSettings) || g.find((x)=> x.isGeneralSettingSymbol)
                  })
                  let generalSettings = symbolTypeDataOrdered.filter((g)=> g[0].hasProfileSettings || g[0].isGeneralSettingSymbol)
                  let optionSettings = symbolTypeDataOrdered.filter((g)=> !g[0].hasProfileSettings && !g[0].isGeneralSettingSymbol)
                  let optionsConcat = []
                  optionSettings.forEach((g)=>{
                    let gr = g.map((value,i)=>{return{...value, showValues: i === 0}})
                    optionsConcat = optionsConcat.concat(gr)
                  })

                  let unionGroups = [...generalSettings]
                  if(optionsConcat.length !== 0) unionGroups = [...unionGroups, optionsConcat]
                  return this.createTypeTables(key, unionGroups)
                })}
                
              </div>
            </CardBody>
          </Card>
        </GridItem>
        
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => ({
	report:{
    ...state.ibReports.ibContractDetails,
  },
  currencies: state.currencies.list,
	profiles: state.profiles.list,
  ibTrees: state.ibTrees.list,
  symbols: state.symbols.list,
  symbolGroups: state.symbolGroups.list
})

const mapDispatchToProps = (dispatch) => ({
  fetch: (params) => dispatch(adminReportContractDetailsFetch(params)),
  profilesFetch: () => dispatch(profilesFetch()),
  profileFilter: (filter) => dispatch(profileFilter(filter)),
  ibTreesFetch: (data) => dispatch(profileIbTreeFetch(data)),
  symbolsFetch: () => dispatch(symbolsFetch()),
  symbolFilter: (filter) => dispatch(symbolFilter(filter)),
  symbolGroupsFetch: () => dispatch(symbolGroupsFetch()),
  symbolGroupFilter: (filter) => dispatch(symbolGroupFilter(filter)),
  profileSpecialCasesFetch: (profile) => dispatch(profileSpecialCasesFetch(profile)),
  subProfileRulesFetch: (subProfile) => dispatch(subProfileRulesFetch(subProfile)),
  currenciesFetch: () => dispatch(currenciesFetch()),
  currencyFilter: (filter) => dispatch(currencyFilter(filter)),
})

export default withStyles({...styles, ...selectStyles})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/ContractDetailsReport/AdminContractDetails.jsx